export default __webpack_public_path__ + "static/media/cz.13fa5f4d.svg";